import { Link } from 'react-router-dom';
import logoUrl from '@/assets/logo.png';
import User from './User';
import SelectType from './SelectType';
import styles from './header.module.css';

const Header: React.FC = () => {
  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <Link to="/" className={styles.logo}>
          <img src={logoUrl} alt="logo" width="160" />
        </Link>
        <div className={styles.info}>
          <SelectType />
          <User />
        </div>
      </div>
    </header>
  );
};

export default Header;
